// extracted by mini-css-extract-plugin
module.exports = {"container":"PopupBox__container___2xLnn","close":"PopupBox__close___3aueM"};